import { render, staticRenderFns } from "./yzcode.vue?vue&type=template&id=84b53324&scoped=true&"
import script from "./yzcode.vue?vue&type=script&lang=js&"
export * from "./yzcode.vue?vue&type=script&lang=js&"
import style0 from "./yzcode.vue?vue&type=style&index=0&id=84b53324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b53324",
  null
  
)

export default component.exports